<template>
  <el-table-column
    prop="invoice_book_template.name"
    label="Sablon"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.invoice_book_template && scope.row.invoice_book_template.name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'invoice_book_template.name',
  };
</script>
